<template>
  <v-layout column>
    <v-toolbar
      dense flat
      :style="{background: (icon? 'transparent' : 'none' )}"
      :class="{'mx-0': !icon,  'x-label-toolbar': !icon }">
      <v-toolbar-title class="pl-0 body-1">
        <v-icon small class="mr-1" color="teal" v-if="icon">{{icon}}</v-icon>
        {{label}}
      </v-toolbar-title>
      <v-spacer/>
      <file-upload
        :input-id="inputId"
        class="v-btn v-btn--flat v-btn--round blue--text text--darken-1"
        :post-action="action"
        :chunk-enabled="chunkEnabled"
        :chunk="{
            action: action,
            minSize: chunkMinSize,
            maxActive: chunkMaxActive,
            maxRetries: chunkMaxRetries
          }"
        :extensions="extensions"
        :accept="accept"
        :multiple="multiple"
        :directory="false"
        :size="size * 1024 * 1024"
        v-model="files"
        :data="{}"
        @input-filter="inputFilter"
        @input-file="inputFile"
        ref="upload">
        <!--:data="extraData"-->

        <div class="v-btn__content" style="height: 100%" v-if="!disabled">
          <i aria-hidden="true" class="v-icon material-icons">publish</i>
          上传附件
        </div>
      </file-upload>
    </v-toolbar>

    <v-divider/>

    <v-card-text>
      <v-data-table
        class="dense"
        :headers="headers"
        :items="files"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <td>{{props.index + 1}}</td>
          <td>
            <div class="x-three-line-ellipsis">
              {{props.item.name}}
            </div>
          </td>
          <td>
            <div v-if="props.item.error" class="error--text">
              {{errors[props.item.error] || props.item.error}}
            </div>
            <div v-else-if="props.item.success" class="blue--text">上传成功</div>
            <div v-else-if="props.item.active" class="text-xs-center">
              <v-progress-linear v-model="props.item.progress" style="margin: 0"></v-progress-linear>
              <div>{{props.item.progress | percent}}</div>
            </div>
          </td>
          <td>{{props.item.size | fileSize }}</td>
          <td class="justify-right layout px-0">
            <v-tooltip top v-if="props.item.active && !props.item.success">
              <v-btn icon class="mx-0" slot="activator"
                     :disabled="disabled || props.item.success || props.item.error.length > 0"
                     @click="$refs.upload.update(props.item, {active: false})">
                <v-icon color="teal">stop</v-icon>
              </v-btn>
              <span>停止上传</span>
            </v-tooltip>
            <v-tooltip top v-if="!props.item.active && !props.item.success">
              <v-btn icon class="mx-0" slot="activator"
                     :disabled="disabled || props.item.success || (props.item.error.length > 0)"
                     @click="$refs.upload.update(props.item, {active: true})">
                <v-icon color="teal">play_arrow</v-icon>
              </v-btn>
              <span>开始上传</span>
            </v-tooltip>
            <v-tooltip top v-if="props.item.success">
              <v-btn icon class="mx-0" slot="activator"
                     :disabled="!props.item.success || props.item.active"
                     :href="`${action.split('?')[0]}/view/${props.item.dbid}`"
                     target="_blank">
                <v-icon color="teal">more_horiz</v-icon>
              </v-btn>
              <span>查看</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     :disabled="!props.item.success"
                     :href="`${action.split('?')[0]}/${props.item.dbid}`"
                     target="_self">
                <v-icon color="teal">arrow_downward</v-icon>
              </v-btn>
              <span>下载</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     :disabled="disabled || props.item.active"
                     @click="() => {
                        if(deleteRemote && props.item.dbid){
                          deleDbid = props.item.dbid;
                          deleMsg = props.item.name;
                          dele = true;
                        } else {
                          $refs.upload.remove(props.item)
                        }
                       }
                      ">
                <v-icon color="pink">delete_forever</v-icon>
              </v-btn>
              <span>删除</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
      <div v-if="description">
        <v-divider/>
        <v-subheader v-if="!isArray(description)">说明：{{description}}</v-subheader>
        <div v-else>
          <v-subheader>附件填写说明：</v-subheader>
          <ol class="pl-5">
            <li v-for="d in description" style="color: rgba(0,0,0,0.54);">{{d}}</li>
          </ol>
        </div>
      </div>
    </v-card-text>

    <x-delete
      v-if="deleteRemote"
      v-model="dele"
      :message="deleMsg"
      :uri="action.split('?')[0]"
      :dbid="deleDbid"
      v-on:ok="() => {
        const fo = files.find(f => f.dbid === deleDbid);
        $refs.upload.remove(fo)
      }"
    />
  </v-layout>
</template>

<script>
  import FileUpload from 'vue-upload-component'
  import XDelete from '@/components/global/Delete'

  export default {
    props: {
      value: {
        type: Array,
        default: () => []
      },
      inputId: {
        type: String,
        default: () => Math.random().toString(36).substr(2)
      },
      label: {
        type: String,
        default: () => ""
      },
      action: {
        type: String,
        default: () => ""
      },
      size: {
        // 单位 M
        type: Number,
        default: () => 10
      },
      multiple: {
        type: Boolean,
        default: () => true
      },
      extensions: {
        type: String,
        default: () => "gif,jpg,jpeg,png,webp,pdf,doc,xls,ppt,docx,xlsx,pptx,gz,zip,rar,7z"
      },

      accept: {
        type: String,
        default: () =>
          ['image/png',
            'image/gif',
            'image/jpeg',
            'image/webp',
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/x-gzip',
            'application/zip',
            'application/x-rar',
            'application/x-7z-compressed"'].join(',')
      },

      // group: {
      //   type: String,
      //   default: () => null
      // },
      //
      // ownerId: {
      //   type: String,
      //   default: () => null
      // },

      disabled: {
        type: Boolean,
        default: () => false
      },

      deleteRemote: {
        type: Boolean,
        default: () => false
      },

      icon: {
        type: String,
        default: () => null
      },

      description: {
        default: () => ""
      }
    },

    components: {FileUpload, XDelete},
    data() {
      return {
        files: [],
        chunkEnabled: true,
        chunkMinSize: 0, // force to use chunked upload.
        chunkMaxActive: 3,
        chunkMaxRetries: 5,

        headers: [
          {text: '#', sortable: false, value: 'rank', width: 18},
          {text: '文件名', sortable: false, value: 'name'},
          {text: '状态', sortable: false, value: 'size', width: 150},
          {text: '大小', sortable: false, value: 'size', width: 120},
          {text: '操作', sortable: false, value: 'dbid', width: 120}
        ],

        errors: {
          size: `文件超过 ${this.size}M.`,
          extension: "文件类型错误.",
          timeout: "上传超时.",
          abort: "已取消上传.",
          network: "网络错误",
          server: "服务器错误.",
          denied: "禁止上传."
        },

        dele: false,
        deleDbid: null,
        deleMsg: null,
      }
    },

    watch: {
      value(nv, ov) {
        //console.log(" in upload value");
        const remoteDefault = {
          dbid: null,
          name: null,
          size: null,
          type: null,

          file: null,
          fileObject: true,
          success: true,
          progress: "100.00",
          active: false,
          response: {},
          speed: 0,
          timeout: 0,
        };

        // window.console.log("in Uploader value.");
        // window.console.log(nv);

        if (nv.length <= 0) {
          this.$refs.upload.clear();
          return;
        }

        const fileObjs =
          nv.filter(v => !v.local)
            .map(v => {
              return Object.assign(
                {},
                remoteDefault,
                {
                  dbid: v.dbid,
                  name: v.fileName,
                  size: v.size,
                  type: v.contentType
                }
              )
            });

        if (fileObjs.length > 0) {
          // window.console.log("fileObjs");
          // window.console.log(fileObjs);

          // 删除控件中的，原有文件
          this.$refs.upload.clear();
          this.$refs.upload.add(fileObjs);

          this.$emit('input', nv.map(v => {
            v.local = true;
            return v;
          }));
        }
      }
    },

    methods: {
      isArray(value) {
        return Array.isArray(value)
      },

      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Before adding a file
          // 添加文件前
          // Filter system files or hide files
          // 过滤系统文件 和隐藏文件
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }
          // Filter php html js file
          // 过滤 php html js 文件
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }

          // Bug: not work
          // if (this.ownerId) {
          //   newFile.data.ownerId = this.ownerId
          // }
          // if (this.group) {
          //   newFile.data.group = this.group
          // }
        }
      },
      inputFile(newFile, oldFile) {
        if (newFile && !oldFile) {
          // add
          // window.console.log('add', newFile);
          // 自动开始上传
          this.$refs.upload.active = true
        }
        if (newFile && oldFile) {
          // update
          // 获取服务器端文件主键（sessionId --> dbid）
          if (newFile.chunk && !newFile.dbid) {
            this.$refs.upload.update(newFile, {dbid: newFile.chunk.sessionId})
          }

          // 文件上传完成
          if (newFile.dbid && newFile.success) {
            const nv = this.value.concat(
              [{
                dbid: newFile.dbid,
                fileName: newFile.name,
                contentType: newFile.type,
                size: newFile.size,
                local: true
              }]
            );

            this.$emit('input', nv);
          }
          // window.console.log('update', newFile)
        }
        if (!newFile && oldFile) {
          // remove
          // window.console.log('remove', oldFile);

          // 文件上传完成
          if (oldFile.dbid && oldFile.success) {
            const nv = this.value.filter(v => v.dbid !== oldFile.dbid);
            this.$emit('input', nv);
          }
        }
      },
      onDelete(file) {
        if (!this.deleteRemote) {
          this.$refs.upload.remove(file)
        } else {

        }
      }
    }
  }
</script>


